import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Box, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import moment, { Moment } from "moment";
import { useAppDispatch } from "../../../redux/store";
import { LoadingSpinner } from "../../../components/ui/loadinSpinner";
import { getPatientDetailsDiagnosisGraphData } from "../../../redux/mis/misReducer";
import HorizontalBar from "../../../components/charts/horizontalBar";
import routesName from "../../../constants/routesName";

const Diagnosis = ({
  fromDate,
  toDate,
  country,
  state,
  district,
  taluk,
  hobli,
  serviceType,
  filterApplyToggle,
  hospitalId
}: {
  fromDate: any;
  toDate: any;
  country: string;
  state: string;
  district: string;
  taluk: string;
  hobli: string;
  serviceType: number;
  filterApplyToggle: boolean;
  hospitalId?: number;
}) => {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();
  const diagnosisData = useSelector(
    (data: any) => data.getPatientDetailsDiagnosisGraphData
  );

  const [errorMessage, setErrorMessage] = useState<string>("");
  const [diagnosisGraphData, setDiagnosisGraphData] = useState<any>([]);

  interface Hospital {
    name: string;
    patientsCount: number;
    percentage: number;
  }

  let names: string[] = [];
  let totalCount: number[] = [];
  let percentage: number[] = [];

  let name: string[] = [];
  let totalCounts: number[] = [];
  let percentages: number[] = [];

  let othersCount: number[] = [];
  let othersPercentage: number[] = [];

  diagnosisGraphData?.patientDetailsSummary?.patientsCountList?.forEach(
    (hospital: Hospital, index: number) => {
      if (index < 4) {
        names.push(hospital.name);
        totalCount.push(hospital.patientsCount);
        percentage.push(hospital.percentage);
      } else {
        othersCount.push(hospital.patientsCount);
        othersPercentage.push(hospital.percentage);
      }
    }
  );

  const otherCount = othersCount?.reduce(
    (acc: number, curr?: number) => acc + (curr ?? 0),
    0
  );
  const otherPercentage = othersPercentage?.reduce(
    (acc: number, curr?: number) => acc + (curr ?? 0),
    0
  );

  const newObjectAtIndex5 = {
    name: "Others",
    patientsCount: otherCount,
    percentage: otherPercentage,
  };

  const index = 4;
  const value = newObjectAtIndex5;
  const newArr = [];
  for (
    let i = 0;
    i < diagnosisGraphData?.patientDetailsSummary?.patientsCountList.length;
    i++
  ) {
    if (i === index) {
      newArr.push(value);
    }
    newArr.push(
      diagnosisGraphData?.patientDetailsSummary?.patientsCountList[i]
    );
  }

  if (othersCount.length > 0) {
    newArr.forEach((hospital: Hospital, index: number) => {
      if (index < 5) {
        name.push(hospital.name);
        totalCounts.push(hospital.patientsCount);
        percentages.push(hospital.percentage);
      }
    });
  }

  const ctx = document.createElement("canvas").getContext("2d");
  const gradient = ctx?.createLinearGradient(0, 0, 200, 0);
  if (gradient) {
    gradient.addColorStop(0, "#D2EEE6");
    gradient.addColorStop(1, "#69C7AE");
  }

  const data = {
    labels: othersCount.length > 0 ? name : names,
    datasets: [
      {
        label: "value",
        backgroundColor: gradient,
        barPercentage: 0.6,
        borderColor: "#98D9C7",
        borderWidth: 1,
        hoverBackgroundColor: gradient,
        hoverBorderColor: "#98D9C7",
        data: othersCount.length > 0 ? totalCounts : totalCount,
      },
    ],
  };

  useEffect(() => {
    if (diagnosisData?.status === "success") {
      setErrorMessage("");
      setDiagnosisGraphData(diagnosisData?.data?.data ?? []);
    } else if (diagnosisData?.status === "failed") {
      setErrorMessage("Something went Wrong");
    }
  }, [diagnosisData]);

  useEffect(() => {
    dispatch(
      getPatientDetailsDiagnosisGraphData({
        country: country,
        state: state,
        district: district,
        taluk: taluk,
        hobli: hobli,
        serviceType: serviceType,
        fromDate: moment(fromDate).format("YYYY-MM-DD"),
        toDate: moment(toDate).format("YYYY-MM-DD"),
        hospitals: [],
        hospitalId: hospitalId,

      })
    );
  }, [filterApplyToggle, fromDate, toDate]);

  return (
    <>
      <div className="p-4 bg-white border border-gray-250 shadow-sm1 rounded-lg w-full">
        <div className="w-full flex items-center justify-between block pb-2 border-b-[0.5px] border-opacity-50 border-dashed border-gray-450">
          <span className="text-18 font-medium text-primary">Diagnosis</span>
          <div className="flex items-center gap-2">
            <div className="border-r-2 border-gray-250">
              <button
                type="button"
                style={{ marginRight: "12px" }}
                onClick={() => navigate(routesName.misDiagnosis)}
              >
                <span className="text-14 font-[700] capitalize text-[#534FA1]">
                  Hospital List
                </span>
              </button>
            </div>

            <button
              type="button"
              onClick={() =>
                navigate(routesName.MisGraphs, {
                  state: { label: "Diagnosis", hospitalId: hospitalId },
                })
              }
            >
              <span className="text-14 font-[700] capitalize text-[#534FA1]">
                View All
              </span>
            </button>
          </div>
        </div>
        {diagnosisData?.isLoading ? (
          <div className="flex justify-center items-center h-full">
            <LoadingSpinner />
          </div>
        ) : (
          <>
            {diagnosisGraphData?.patientDetailsSummary?.patientsCountList
              ?.length > 0 ? (
              <>
                <div className="pt-2 flex items-center">
                  <div className="border-r-2 border-gray-250">
                    <span className="text-14 font-[400] text-secondary">
                      No. of Diagnosis :
                    </span>
                    <span className="text-14 font-[700] text-primary pl-1 pe-2">
                      {diagnosisGraphData?.patientDetailsSummary?.totalNos.toLocaleString(
                        "en-IN"
                      )}
                    </span>
                  </div>

                  <span className="text-14 font-[400] text-secondary ps-3">
                    No. of patients :
                  </span>
                  <span className="text-14 font-[700] text-primary pl-1">
                    {diagnosisGraphData?.totalPatientsCount.toLocaleString(
                      "en-IN"
                    )}
                  </span>
                </div>
                {/* <Box sx={{ marginTop: "6px" }}> */}
                <div className="h-full pb-14">
                  <HorizontalBar
                    data={data}
                    percentage={
                      othersCount.length > 0 ? percentages : percentage
                    }
                    title="Diagnosis"
                  />
                </div>

                {/* </Box> */}
              </>
            ) : (
              <>
                <div className="flex justify-center items-center h-full">
                  <span className="text-18 font-medium text-primary">
                    No Data Found
                  </span>
                </div>
              </>
            )}
          </>
        )}
      </div>
    </>
  );
};
export default Diagnosis;
